var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0004 3.60156C16.0908 3.60156 14.2595 4.36013 12.9092 5.71039C11.559 7.06066 10.8004 8.892 10.8004 10.8016C10.8004 12.7111 11.559 14.5425 12.9092 15.8927C14.2595 17.243 16.0908 18.0016 18.0004 18.0016C19.91 18.0016 21.7413 17.243 23.0916 15.8927C24.4418 14.5425 25.2004 12.7111 25.2004 10.8016C25.2004 8.892 24.4418 7.06066 23.0916 5.71039C21.7413 4.36013 19.91 3.60156 18.0004 3.60156ZM12.6004 10.8016C12.6004 9.36939 13.1693 7.99588 14.182 6.98319C15.1947 5.97049 16.5682 5.40156 18.0004 5.40156C19.4326 5.40156 20.8061 5.97049 21.8188 6.98319C22.8315 7.99588 23.4004 9.36939 23.4004 10.8016C23.4004 12.2337 22.8315 13.6072 21.8188 14.6199C20.8061 15.6326 19.4326 16.2016 18.0004 16.2016C16.5682 16.2016 15.1947 15.6326 14.182 14.6199C13.1693 13.6072 12.6004 12.2337 12.6004 10.8016ZM9.01659 19.8016C8.54254 19.7997 8.07277 19.8914 7.63423 20.0714C7.1957 20.2515 6.79702 20.5163 6.46106 20.8508C6.1251 21.1852 5.85846 21.5827 5.67645 22.0204C5.49444 22.4582 5.40062 22.9275 5.40039 23.4016C5.40039 26.4454 6.89979 28.7404 9.24339 30.2362C11.551 31.7068 14.6614 32.4016 18.0004 32.4016C21.3394 32.4016 24.4498 31.7068 26.7574 30.2362C29.101 28.7422 30.6004 26.4436 30.6004 23.4016C30.6004 22.4468 30.2211 21.5311 29.546 20.856C28.8708 20.1808 27.9552 19.8016 27.0004 19.8016H9.01659ZM7.20039 23.4016C7.20039 22.4062 8.00679 21.6016 9.01659 21.6016H27.0004C27.4778 21.6016 27.9356 21.7912 28.2732 22.1288C28.6107 22.4663 28.8004 22.9242 28.8004 23.4016C28.8004 25.7578 27.6808 27.5128 25.789 28.717C23.863 29.9464 21.1234 30.6016 18.0004 30.6016C14.8774 30.6016 12.1378 29.9464 10.2118 28.717C8.32179 27.511 7.20039 25.7596 7.20039 23.4016Z",
    fill: "url(#paint0_linear_1259_13987)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1259_13987",
    x1: 9.52355,
    y1: -3.43027,
    x2: -6.14994,
    y2: 42.0897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4DA50"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonicon);
export default __webpack_public_path__ + "static/media/personicon.e3eeb0dcf2bb9f67f17bbc4524837249.svg";
export { ForwardRef as ReactComponent };